import { render, staticRenderFns } from "./thumb.vue?vue&type=template&id=73711021&scoped=true&"
import script from "./thumb.vue?vue&type=script&lang=js&"
export * from "./thumb.vue?vue&type=script&lang=js&"
import style0 from "./thumb.vue?vue&type=style&index=0&id=73711021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73711021",
  null
  
)

export default component.exports